import { render, staticRenderFns } from "./order-return-product-table.vue?vue&type=template&id=5944c9ae&"
import script from "./order-return-product-table.vue?vue&type=script&lang=js&"
export * from "./order-return-product-table.vue?vue&type=script&lang=js&"
import style0 from "./order-return-product-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports